import React from "react"

import { useBlogPosts } from "src/hooks/use-blog-posts"
import Post from "components/blog/post"

import * as s from "./posts.module.sass"

const Posts = (props) => {
  const { posts } = props
  const postsList = posts || useBlogPosts()

  return (
    <div className={s.component}>
      <div className="container">
        <div className={s.posts}>
          {postsList.map((post, index) => (
            <Post key={post.slug} post={post} index={index} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default Posts
